//* 文件打包的代码如下
// 打包此文件时，请使用 package.json 中的 build-cf 脚本
// 例子：.../core: $ yarn build-cf
// 或者：.../core: $ yarn webpack --config cf.webpack.config.js
//* 注意上方命令的空格

import { CustomFurniture } from '../logic/Controller/CustomFurniture'
import { Base } from '../logic/Controller/Base'
import { Main as ShapeMain } from '../logic/contour_editor/special_shape_editor/Main'
import { StorageMgr } from '../core'
import { MaterialMgr } from '../logic/base_action/MaterialMgr'
import { holeLJFSList } from '../logic/hole_slot/HoleMgr'
import { ThreeTools } from '../logic/ThreeTools'
import { CustomFur } from '../core/pb/furniture'
import { common_storage } from '../common/common_storage'
import { CrossPanelTiltHdlr } from '../logic/utility_class/CrossPanelTiltHdlr'

/**
 * 获取渲染用的柜体模型
 * @description 由于此文件会用于打包，故需要设定此函数为全局状态下的方法
 * @description 由于渲染代码会在服务端运行，故此处使用globalThis，而不是window
 * @param {*} pbs 单个柜体的pb数据
 * @returns {THREE.Object3D} 基于threejs坐标系的柜体模型
 */
globalThis.getRenderMesh = function (pbs, options) {
    //? 调试代码 后续删除
    globalThis.selectPath = []

    // 渲染模式的必要全局环境搭建
    Base.isRender = true // 使全局进入渲染模式，避免执行运行时的代码，以致于报错
    common_storage.IS_RENDER = true
    common_storage.DEPS = {
        ossURL: 'https://tubusi01.oss-cn-beijing.aliyuncs.com',
    }

    Base.deps.ShapeMain = ShapeMain // 异形的相关代码
    if (!StorageMgr.datas.DEPS) StorageMgr.datas.DEPS = {}
    StorageMgr.datas.DEPS.ossURL = options.ossURL
    Base.deps.MaterialMgr = MaterialMgr
    Base.deps.holeLJFSList = holeLJFSList
    Base.deps.ThreeTools = ThreeTools
    Base.deps.CrossPanelTiltHdlr = CrossPanelTiltHdlr

    // 生成柜体模型
    const pbsObj = new CustomFur.CustomFurniture.toObject(pbs)
    const box = new CustomFurniture(pbsObj, true).getRenderMesh(pbs)

    // 借由 box 的 userData ，获取指定数据
    const renderDatas = []
    box?.traverse((child) => {
        if (child?.userData?.renderDatas) {
            renderDatas.push(...child.userData.renderDatas)
        }
    })

    return { box, renderDatas }
}
